export const PODCAST_LS_TOKEN = "podcast-token";

export enum UserMenu {
  Category = "Category",
  Subscriptions = "Subscriptions",
  Home = "Home",
  Search = "Search",
  Profile = "Profile",
}
